import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatformAppContext } from '@/app/platform/platform-context/platform-app-context';
import { UserModule } from '@/app/platform/platform-core/user/user.module';
import { FeatureAccessDirective } from './directives/feature-access.directive';
import { ClicktroughAccessLinkDirective } from './directives/clicktrough-access-link.directive';
import { PlatformUserContext } from '@/app/platform/platform-context/platform-user-context';
import { PlatformNavigationContext } from '@/app/platform/platform-context/platform-navigation.context';
import { FeatureElementAccessToggler } from '@/app/platform/platform-context/feature-element-access-toggler';

@NgModule({
  declarations: [FeatureAccessDirective, ClicktroughAccessLinkDirective],
  imports: [CommonModule, UserModule],
  providers: [
    PlatformAppContext,
    PlatformNavigationContext,
    FeatureElementAccessToggler,
    PlatformUserContext
  ],
  exports: [FeatureAccessDirective, ClicktroughAccessLinkDirective]
})
export class PlatformContextModule {}
